import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SidemenuPaths } from '../drawer-sidemenu/routes';
import { Button, Icon } from '@innovationnorway/cl-react';
import './OpenMenuInfoButton.scss';
import useSiteimprove from 'src/hooks/use-siteimprove';
import { useLocation } from 'react-router-dom';
import { SITEIMPROVE_DECLARATIONS } from 'src/features/tracking/constants';
type Props = {
  page: SidemenuPaths;
  smallIcon?: boolean;
  /** Adds a black ring and a black question mark, for contrast on tinted surfaces. */
  bordered?: boolean;
};
export const OpenMenuInfoButton: React.FC<Props> = ({ page, smallIcon, bordered }) => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');
  const siteimprove = useSiteimprove();
  const location = useLocation();
  return (
    <Button
      className={classNames('open-menu-info-button', {
        'open-menu-info-button--bordered': bordered,
      })}
      aria-label={tHelpAndSupport('helpAndSupport.Open')}
      type="button"
      icon
      variant="tertiary"
      data-size="sm"
      onClick={() => {
        siteimprove?.log(SITEIMPROVE_DECLARATIONS.OPEN_HELP_MENU.id, page, location.pathname);
        window.dispatchEvent(
          new CustomEvent('openSideMenu', {
            detail: page,
          }),
        );
      }}
    >
      <Icon
        prefix="fass"
        iconName="circle-question"
        className={smallIcon ? 'open-menu-info-button__icon-small' : 'open-menu-info-button__icon'}
      />
    </Button>
  );
};
export default OpenMenuInfoButton;
